import React, { useState, useEffect } from 'react';
import router from 'umi/router';
import styles from './index.less';

import paySuccess from 'images/ico_paysuccessfully@2x.png';
import unionPaySuccess from 'images/pay_success_unionpay.png';

let timer = null;

const UseSucModal = (props = {}) => {
  const [record, setRecord] = useState({});
  const [isShow, setIsShow] = useState(false);
  const { channel } = props;
  const clearTimer = () => {
    clearInterval(timer);
    timer = null;
  };
  useEffect(() => {
    const isShowUseSucModal = sessionStorage.getItem('isShowUseSucModal') === 'true';
    const dragoncode = localStorage.getItem('dragoncode') !== 'undefined';
    clearTimer();
    timer = setInterval(() => {
      // layouts页面初始化的时候设置为true
      if (isShowUseSucModal && dragoncode) {
        window.g_app._store.dispatch({
          type: 'global/getRecord',
          payload: {
            dragoncode: localStorage.getItem('dragoncode'),
            language: localStorage.getItem('language'),
          },
          callback: (res) => {
            const record = res.data.data;
            console.log('核销成功', res);
            if (JSON.stringify(record) !== '{}') {
              // 只许弹框一次
              sessionStorage.setItem('isShowUseSucModal', 'false');
              clearTimer();
              setRecord(record);
              setIsShow(true);
            }
          },
          fail: () => {
            clearTimer();
          },
        });
      }
    }, 5000);
    return () => {
      clearTimer();
    };
  }, []);

  const toRecord = () => {
    router.push({
      pathname: '/record',
      query: {
        dragoncode: localStorage.getItem('dragoncode'),
        language: localStorage.getItem('language'),
      },
    });
  };
  const unionPayDom = () => {
    return (
      <div className={styles.unionPayDom}>
        <img className={styles.imgSuccess} src={unionPaySuccess} alt="" />
        <span className={styles.successTip}>刷码成功</span>
        <span className={styles.successTipEn}>Success</span>
        <div className={styles.btn} onClick={() => setIsShow(false)}>
          确定 sure
        </div>
      </div>
    );
  };
  const defalutDom = () => {
    return (
      <div className={styles.useSuccessLayer}>
        <div className={styles.top}>
          刷卡成功
          <img src={paySuccess} className={styles.icon} alt="" />
          <div className={styles.btn} onClick={toRecord}>
            查看更多消费记录
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.inner}>
            <div className={styles.msg1}>
              <div className={styles.loungeName}>{record.loungeName}</div>
              <div className={styles.airportName}>{record.airportName}</div>
            </div>
            <div className={styles.msg2}>
              <div className={styles.cardNo}>
                <span>使用卡号</span>
                <span>{record.draoncode}</span>
              </div>
              <div className={styles.useNum}>
                <span>消费人次</span>
                <span>{record.adult + record.child}</span>
              </div>
              <div className={styles.useTime}>
                <span>消费时间</span>
                <span>{record.consumeTime}</span>
              </div>
            </div>
          </div>
          <div className={styles.btn} onClick={() => setIsShow(false)}>
            关闭
          </div>
        </div>
      </div>
    );
  };
  const getDom = () => {
    if (channel === 'unionpay') {
      return unionPayDom();
    }
    return defalutDom();
  };

  return <>{isShow && <div className={styles.layerWrap}>{getDom()}</div>}</>;
};

export default React.memo(UseSucModal);
